var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"width":_vm.width,"visible":_vm.visible,"cancelDialog":_vm.cancelDialogs,"confirmDialog":_vm.tipsConfirm,"isdeling":_vm.isdeling,"append":""}},[_c('div',{staticClass:"answer"},[_vm._v("确认下载全部电子合同吗？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }